import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgGb = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#EEE",
      d: "m.088 13.46 1.098-1.39-1.1-1.517A12.005 12.005 0 0 1 10.601.082l1.437.697 1.368-.696a12.005 12.005 0 0 1 10.512 10.506l-.687 1.28.69 1.522a12.005 12.005 0 0 1-10.485 10.525l-1.277-.838-1.57.84A12.006 12.006 0 0 1 .087 13.46Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#0052B4",
      d: "M8.869.413a12 12 0 0 0-4.173 2.065L8.87 6.656zM.413 8.869A12 12 0 0 1 2.48 4.693l4.176 4.176zm2.065 10.435a12 12 0 0 1-2.065-4.173h6.239zm6.395 4.285a12 12 0 0 1-4.177-2.067l4.177-4.178zm10.431-2.068a12 12 0 0 1-4.173 2.066v-6.239zm4.283-6.39a12 12 0 0 1-2.067 4.176l-4.176-4.176zM21.521 4.696a12 12 0 0 1 2.066 4.173h-6.239zM15.131.413a12 12 0 0 1 4.176 2.067l-4.176 4.176z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#D80027",
      d: "M12 0q-.796 0-1.566.101v10.333H.101a12 12 0 0 0 0 3.132h10.333v10.333a12 12 0 0 0 3.132 0V13.566h10.333a12 12 0 0 0 0-3.132H13.566V.101A12 12 0 0 0 12 0"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#D80027",
      d: "M3.515 3.515q-.37.369-.705.768L7.392 8.87h1.477zm.768 17.675a12 12 0 0 1-.768-.705l5.354-5.354v1.477zm16.906-1.472q-.337.4-.705.769L15.13 15.13h1.477l4.58 4.587ZM19.716 2.81q.4.336.77.705L15.13 8.869V7.392l4.585-4.582Z"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgGb;